(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hover = matchMedia('(hover: hover)').matches;
  /* 3D tilt on cards */
  if (!reduce && hover) {
    const tilt = (el, max = 8, glare = false) => {
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        el.style.setProperty('--ry', (x * max).toFixed(2) + 'deg');
        el.style.setProperty('--rx', (-y * max).toFixed(2) + 'deg');
        if (glare) { el.style.setProperty('--gx', ((x + .5) * 100) + '%'); el.style.setProperty('--gy', ((y + .5) * 100) + '%'); }
      });
      el.addEventListener('pointerleave', () => { el.style.removeProperty('--rx'); el.style.removeProperty('--ry'); });
    };
    const bind = (root = document) => {
      root.querySelectorAll('.product-card:not([data-pf])').forEach((c) => { c.dataset.pf = 1; tilt(c, 7); });
      root.querySelectorAll('.pup-duo__card:not([data-pf])').forEach((c) => { c.dataset.pf = 1; tilt(c, 9, true); });
    };
    bind();
    new MutationObserver(() => bind()).observe(document.body, { childList: true, subtree: true });
    /* Hero: card follows pointer, blobs parallax */
    document.querySelectorAll('[data-pf-hero]').forEach((hero) => {
      const card = hero.querySelector('.pf-hero__card');
      const blobs = hero.querySelectorAll('.pf-hero__blob');
      hero.addEventListener('pointermove', (e) => {
        const r = hero.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        if (card) { card.style.setProperty('--ry', (x * 22 - 6).toFixed(1) + 'deg'); card.style.setProperty('--rx', (-y * 14 + 2).toFixed(1) + 'deg'); }
        blobs.forEach((b, i) => { const d = (i + 1) * 14; b.style.setProperty('--px', (-x * d).toFixed(1) + 'px'); b.style.setProperty('--py', (-y * d).toFixed(1) + 'px'); });
      });
      hero.addEventListener('pointerleave', () => { if (card) { card.style.removeProperty('--ry'); card.style.removeProperty('--rx'); } });
    });
  }
  /* Flat pop-in reveal */
  if (!reduce && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((en) => en.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.pup-cats, .pup-duo, .section--featured-collection, .collection-list, .pup-faq, .pup-seo').forEach((el) => { el.classList.add('pf-reveal'); io.observe(el); });
  }
})();
